import type { Question } from './model';

export type FoodHighlightTone = 'berry' | 'cocoa' | 'gold' | 'lemon' | 'mint' | 'pink';

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[character]!);
}

export function foodHighlightTone(food: string): FoodHighlightTone {
  if (/jam|berry/i.test(food)) return 'berry';
  if (/chocolate|cocoa|crinkle|éclair/i.test(food)) return 'cocoa';
  if (/star|lemon/i.test(food)) return 'lemon';
  if (/sprinkle|pink|macaron|cupcake/i.test(food)) return 'pink';
  if (/gingerbread|cinnamon/i.test(food)) return 'mint';
  return 'gold';
}

export function highlightedStoryHtml(question: Question): string {
  const index = question.story.indexOf(question.food);
  if (index < 0) return escapeHtml(question.story);
  const before = question.story.slice(0, index);
  const after = question.story.slice(index + question.food.length);
  const tone = foodHighlightTone(question.food);
  const highlightedFood = `<strong class="food-highlight food-${tone}">${escapeHtml(question.food)}</strong>`;
  if (before.endsWith('How many ') && after.startsWith('?')) {
    const leadIn = before.slice(0, -'How many '.length);
    return `${escapeHtml(leadIn)}<span class="story-question">How many ${highlightedFood}?</span>${escapeHtml(after.slice(1))}`;
  }
  return `${escapeHtml(before)}${highlightedFood}${escapeHtml(after)}`;
}

export function equationHtml(question: Question, revealAnswer: boolean): string {
  if (!revealAnswer) return escapeHtml(question.equation);
  const [before, after = ''] = question.equation.split('?');
  return `${escapeHtml(before!)}<strong class="equation-answer">${question.answer}</strong>${escapeHtml(after)}`;
}

export function equationWidthClass(question: Question, revealAnswer: boolean): string {
  const displayedEquation = revealAnswer ? question.equation.replace('?', String(question.answer)) : question.equation;
  const compactLength = displayedEquation.replace(/\s/g, '').length;
  if (compactLength >= 9) return 'equation-extra-wide';
  if (compactLength >= 7) return 'equation-wide';
  return '';
}
